import { Card, Heading, Paragraph } from '@zillow/constellation-10';

import { FULLSTORY_EXCLUDE } from '../../../../constants/analytics';

type Props = {
  cancellationReason: string;
};

export default function CancellationConfirmation({ cancellationReason }: Props): JSX.Element {
  return (
    <Card tone="soft" elevated={false} outlined={false} className={FULLSTORY_EXCLUDE}>
      <Heading
        level={2}
        css={{
          textStyle:
            'responsive.body-lg-bold' /* oxlint-disable-line constellation/no-unknown-token -- valid textStyle; rule can't check textStyle (JSINFRA-3580) */,
        }}
      >
        Your reason for canceling
      </Heading>
      <Paragraph css={{ textStyle: 'body-sm', fontStyle: 'italic' }}>“{cancellationReason}”</Paragraph>
    </Card>
  );
}
